import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    required,
    email,
    numeric,
    length,
    regex
    // eslint-disable-next-line camelcase
    // alpha_dash
} from 'vee-validate/dist/rules'
extend('required', {
    ...required,
    message: 'This field is required'
})
extend('email', {
    ...email,
    message: 'Please enter a valid email'
})
extend('numeric', {
    ...numeric,
    message: 'Please enter a valid number'
})
extend('regex', {
    ...regex,
    message: 'Please enter a valid name'
})
// extend('alpha_dash', {
//     // eslint--next-line camelcase
//     ...alpha_dash,
//     message: 'Please enter a valid name'
// })
extend('length', {
    ...length,
    message: ''
})
export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            hints: {
                email: '',
                password: '',
                purchaseOrder: ''
            },
            loader: false
        }
    }
}
